import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import fetch from "cross-fetch"
import queryString from "query-string"
import FormLoader from "../form-loader"
import FormBuilder from "./formBuilder"
import Text from "../s22_text"
import { addCookieData } from "../../helpers/handleCookies"
import { find, endsWith } from "lodash"

class FsApi extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formFields: [],
      submitTitle: "Submit",
      completed: false,
      loaded: false,
      text: "",
      submitting: false,
      contact: null,
    }

    this.submitForm = this.submitForm.bind(this)
  }

  componentDidMount() {
    fetch(`${process.env.GATSBY_LANDINGPAGE_API}/lp-form`, {
      method: "POST",
      body: JSON.stringify({
        formId: this.props.blok.formId,
      }),
    })
      .then((resp) => {
        return resp.json()
      })
      .then((data) =>
        this.setState({
          formFields: data.fields,
          submitTitle: data.submit_title,
          loaded: true,
        })
      )

    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S

      if (contactId) {
        fetch(
          `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
          {
            method: "post",
            body: JSON.stringify({ contactID: contactId }),
          }
        )
          .then((resp) => {
            return resp.json()
          })
          .then((data) => {
            this.setState({
              contact: JSON.parse(data),
            })
          })
      } else {
        this.setState({
          contact: {},
        })
      }
    }
  }

  submitForm(data, fields) {
    const { formFields } = this.state
    const { blok } = this.props
    let endPointName = "lp-form"
    const parentField = find(fields, (f) => {
      return f.name === "i_am_a"
    })

    const formType = find(fields, (f) => f.name.startsWith("form_type"))
    if (formType && formType.value) {
      data.dataType = formType.value
    }

    if (
      (blok.isParent &&
        parentField !== undefined &&
        parentField.value !== undefined &&
        parentField.value === "Parent") ||
      (formType !== undefined && formType.value === "REFERRAL")
    ) {
      endPointName = "sqs-form"
    }

    this.setState({ submitting: true }, () => {
      fetch(`${process.env.GATSBY_LANDINGPAGE_API}/${endPointName}`, {
        method: "POST",
        body: JSON.stringify({
          formId: this.props.blok.formId,
          data,
          cookie: addCookieData({}),
        }),
      })
        .then((resp) => {
          return resp.json()
        })
        .then((respObj) => {
          if (respObj.redirect_url) {
            if (typeof window !== "undefined")
              window.location = respObj.redirect_url
          } else {
            this.setState({ submitting: false, completed: true }, () => {
              this.props.onSumbitFormData(formFields, data)
            })
          }

          window.dataLayer.push({
            event: "formSubmission",
            formType: this.getFieldDataValue(fields, "sf_formtype"),
            program: this.getFieldDataValue(fields, "sf_selectyourprogram"),
          })

          window.dataLayer.push({
            event: "form_success",
            eventMeta: {
              form_platform: "formstack",
              form_type: this.getFieldDataValue(fields, "sf_formtype"),
            },
          })
        })
    })
  }

  getFieldDataValue(fields, name) {
    const key = Object.keys(fields).find((key) =>
      endsWith(fields[key].name, name)
    )
    return key ? fields[key].value : ""
  }

  getFSWrapperClass() {
    const { blok } = this.props
    const { completed, loaded } = this.state

    if (completed) {
      return " fs-wrapper--hidden"
    } else if (!blok._editable && !loaded) {
      return " fs-wrapper--loading"
    }
    return ""
  }

  render() {
    const { blok } = this.props
    const { formFields, completed, loaded, submitTitle, submitting, contact } =
      this.state
    return (
      <SbEditable content={blok}>
        <div className={`fs-wrapper${this.getFSWrapperClass()}`}>
          {!loaded && <FormLoader className="fs-wrapper__loading" />}
          {loaded && contact && (
            <FormBuilder
              fields={formFields}
              buttonText={submitTitle}
              loaded={loaded}
              onSubmit={this.submitForm}
              submitting={submitting}
              contact={contact}
              prefillValues={this.props.prefillValues}
            />
          )}
        </div>
        <div
          className={`fs-completed-wrapper${
            completed || blok._editable ? " fs-completed-wrapper--done" : ""
          }`}
        >
          {blok.thank_you_copy.length > 0 && (
            <Text blok={blok.thank_you_copy[0]} />
          )}
          {this.props.children}
        </div>
      </SbEditable>
    )
  }
}

FsApi.defaultProps = {
  onSumbitFormData: () => {},
}

FsApi.propTypes = {
  blok: PropTypes.shape({
    formId: PropTypes.string,
    embed_code: PropTypes.string,
    thank_you_copy: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
      })
    ),
  }).isRequired,
  onSumbitFormData: PropTypes.func,
}

export default FsApi
